import angular from 'angular';
import mycrmAllocation from './mycrmAllocation';

export default angular
  .module('components.mycrmAllocation', [])
  .component('mycrmAllocation', mycrmAllocation).name;
